module.exports = __webpack_public_path__ + "img/btn_category_add.52cb0efa.svg";